import React from 'react';
import { useEditorPreview } from '@/components/editor/EditorPreviewContext';

/**
 * Лого «только на десктопе» (пак `chrome.logo: 'desktop-left'`, spec
 * shared/header.md «Десктоп» и «Что добавить» п.7): `fixed`, 60 px слева и
 * 25 px сверху, высота 24 (эталон 96×24), над шапкой; до 920 px скрыто.
 * Рисуется НЕЗАВИСИМО от шапки — виден и на экранах со скрытой шапкой.
 * Разметка — класс `.qb-desktop-logo` в styles/public-paywall.css.
 *
 * В канве конструктора не рисуется: там «телефон», а медиа-запрос мерил бы
 * окно редактора и прибил бы лого к его углу.
 */
export function DesktopLogo({
  url,
  hidden,
  testId = 'quiz-desktop-logo',
}: {
  url: string | undefined;
  hidden: boolean;
  testId?: string;
}) {
  // Признак канвы конструктора берётся тут же (тот же контекст, что у
  // визардов), чтобы и квиз, и пейволл звали лого одной строкой.
  const { isEditorPreview } = useEditorPreview();
  if (!url || hidden || isEditorPreview) return null;
  return (
    <img
      src={url}
      alt=""
      decoding="async"
      className="qb-desktop-logo"
      data-testid={testId}
    />
  );
}
